import { render } from "./LegalPlaceholder.vue?vue&type=template&id=0e1df66a&scoped=true"
import script from "./LegalPlaceholder.vue?vue&type=script&lang=js"
export * from "./LegalPlaceholder.vue?vue&type=script&lang=js"

import "./LegalPlaceholder.vue?vue&type=style&index=0&id=0e1df66a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1df66a"]])

export default __exports__